import { createFileRoute } from '@tanstack/react-router';
import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthFrame } from '@/components/AuthFrame';
import { Field } from '@/components/ui/Field';
import { authClient } from '@/lib/auth-client';
import { Link } from '@/lib/router-compat';

export const Route = createFileRoute('/forgot-password')({ component: ForgotPassword });

function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    const { error: err } = await authClient.requestPasswordReset({ email, redirectTo: `${window.location.origin}/reset-password` });
    setBusy(false);
    // The answer never reveals whether the address exists.
    if (err?.status === 429) return setError(t('auth.tooManyAttempts'));
    setSent(true);
  };

  return (
    <AuthFrame title={t('auth.forgotTitle')} lead={t('auth.forgotLead')}>
      {sent ? (
        <div className="alert alert-success alert-soft text-sm">{t('auth.forgotSent')}</div>
      ) : (
        <form onSubmit={submit}>
          <Field label={t('auth.email')}>
            {(id) => <input id={id} className="input w-full" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />}
          </Field>
          {error && <p className="text-error mt-2 text-sm">{error}</p>}
          <button type="submit" className="btn btn-primary mt-4 w-full" disabled={busy}>
            {busy && <span className="loading loading-spinner loading-sm" />}
            {t('auth.sendLink')}
          </button>
        </form>
      )}
      <Link to="/login" className="btn btn-link btn-sm mt-4 w-full">
        {t('auth.backToSignIn')}
      </Link>
    </AuthFrame>
  );
}
